import { Module } from 'vuex';
import { Company } from './company.interface';
import companyService from './company.service';
import { StoreState } from '@/core/models/store.interface';

export interface CompanyState {
   companies?: Array<Company>;
}

const CompanyStore: Module<CompanyState, StoreState> = {
   namespaced: true,
   state: {
      companies: [],
   },

   getters: {},

   mutations: {
      SET_COMPANIES(state, { companies }) {
         state.companies = companies;
      },
   },

   actions: {
      async get({ state, commit }, { search = '', filter_employer_tenant_id }: { search: string; filter_employer_tenant_id?: number }) {
         if (search === '' && state.companies) return state.companies;

         const COMPANIES = await companyService.get(search, filter_employer_tenant_id).then((response) => response.data);
         if (search === '') commit('SET_COMPANIES', { companies: COMPANIES });
         return COMPANIES;
      },
   },
};

export default CompanyStore;
